/*
 * Copyright (C) 2015 Spanning Cloud Apps LLC.  All rights reserved.
 */

'use strict';
angular
  .module('http.dashboard', [])
  /**
   * Service used to access all calls to the dashboard rest service.
   */
  .factory('httpDashboard', function ($http) {
    /**
     * Returns all the available primary objects for the organization.
     *
     * @returns {promise} A promise that when resolved will include an array of objects.
     */
    var getAvailablePrimaryObjects = function () {
      return $http({
        method: 'GET',
        url: 'api/primaryobjects/available'
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get the primary objects set by the organization.
     *
     * @returns {promise} A promise that when resolved will include the primaryInfo object.
     */
    var getPrimaryObjects = function () {
      return $http({
        method: 'GET',
        url: 'api/primaryobjects/get'
      })
        .then(function (res) {
          return res.data;
        })
        .catch(() => ({}));
    };

    /**
     * Set the primary objects set by the organization.
     *
     * @param {array} primaryObjects - The primary objects to set.
     * @returns {promise} A promise that when resolved will include the primaryInfo object.
     */
    var setPrimaryObjects = function (primaryObjects) {
      return $http({
        method: 'POST',
        url: 'api/primaryobjects/set',
        data: {
          object1: primaryObjects[0].objectName,
          object2: primaryObjects[1].objectName,
          object3: primaryObjects[2].objectName,
          object4: primaryObjects[3].objectName
        }
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      getAvailablePrimaryObjects: getAvailablePrimaryObjects,
      getPrimaryObjects: getPrimaryObjects,
      setPrimaryObjects: setPrimaryObjects
    };
  });
